var map = {
	"./en/button.json": [
		7094,
		94
	],
	"./en/menu.json": [
		1507,
		507
	],
	"./en/page.json": [
		7959,
		959
	],
	"./fr/button.json": [
		2346,
		346
	],
	"./fr/menu.json": [
		8808,
		808
	],
	"./fr/page.json": [
		7507,
		342
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7535;
module.exports = webpackAsyncContext;